import { useState } from "react";
import "./Signup.css";

export default function SignupForm() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: ""
  })

  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setLoading(true);


    try {
      const response = await fetch("https://api.explorelrt.com/signup", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(form).toString(),
      });

      const data = await response.json()

      if (!response.ok) {
        setStatus(data.error);

      } else {
        setStatus(data.message)

      }
    } catch (e) {
      console.log("Network error, please try again.", e);
    } finally {
      setLoading(false);
    }

  };

  return (

    <form onSubmit={handleSignup} className="signupContainer">

      <div className="signupSection">
        <h1>Create an account</h1>
      </div>

      <div className="signupSection">
        <label className="signupLabel" htmlFor="name">
          Username:

        </label>
        <input
          id="name"
          className="signupInput"
          type="text"
          name="name"
          value={form.name}
          onChange={handleChange}
          autoComplete="username"
          required
        />
      </div>

      <div className="signupSection">
        <label className="signupLabel" htmlFor="email">
          Email:
        </label>

        <input
          id="email"
          className="signupInput"
          type="email"
          name="email"
          value={form.email}
          onChange={handleChange}
          placeholder="you@example.com"
          autoComplete="email"
          required
        />
      </div>

      <div className="signupSection">
        <label className="signupLabel" htmlFor="password">
          Password:
        </label>
        <input
          id="password"
          className="signupInput"
          type="password"
          name="password"
          value={form.password}
          onChange={handleChange}
          autoComplete="new-password"
          required
        />
      </div>

      <div className="signupSection">
        {status && <p style={{ color: "gray" }}>{status}</p>}

        <button type="submit" className="signupButton" disabled={loading}>
          {loading ? "Creating Account..." : "Sign Up"}
        </button>
      </div>
    </form>

  );
}
